module.exports = __webpack_public_path__ + "static/media/footer_logo.84dc50e0.png";